import * as React from "react";
import { Login } from "@/components/pages/Login/Login";
import { ProtectedComponent } from "@/components/templates/ProtectedComponent/ProtectedComponent";
import { useCurrentUserPrincipal, useUserHasRoles } from "@/services/UserServices/UserService";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { AccessDenied } from "./components/pages/AccessDenied/AccessDenied";
import { PortalRoutes } from "./components/templates/PortalRoutes/PortalRoutes";
import { SuperUserContext } from "./context/SuperUserContext";
import { usePortalConfig } from "./hooks/PortalConfig";
import { usePages } from "./hooks/PageContent";
import { useCustomers } from "./hooks/Customer";
import { NoCustomers } from "./components/pages/NoCustomers/NoCustomers";

function App() {
	const up = useCurrentUserPrincipal();
	const pc = usePortalConfig();
	const pageContent = usePages();
	const hasSuperUser = useUserHasRoles(["super-user", "impersonate"], true);
	const [impersonatedUserId, setImpersonatedUserId] = React.useState<string | null | undefined>(
		sessionStorage.getItem("impersonated-user") ?? null
	);
	const [isSuperUser, setSuperUser] = React.useState(
		sessionStorage.getItem("is-super-user") === "true" ?? false
	);
	React.useEffect(() => {
		sessionStorage.setItem("is-super-user", isSuperUser ? "true" : "false");
	}, [isSuperUser]);
	React.useEffect(() => {
		sessionStorage.setItem("impersonated-user", impersonatedUserId || "");
	}, [impersonatedUserId]);
	return (
		<SuperUserContext.Provider
			value={{
				isSuperUser: hasSuperUser && isSuperUser && false,
				hasSuperUserRole: hasSuperUser,
				setSuperUser,
				setImpersonatedUser: setImpersonatedUserId,
				impersonatedUserId: impersonatedUserId,
			}}>
			<FluentProvider theme={webLightTheme}>
				<BrowserRouter>
					<Routes>
						{!up.isLoading && !pc.isLoading && !pageContent.isLoading && (
							<>
								{!up.principal?.clientPrincipal && (
									<Route path="/portal/*" element={<Login />}></Route>
								)}
								{up.principal?.clientPrincipal && (
									<Route path="/" element={<Navigate to={"/portal"}></Navigate>} />
								)}
								{up.principal?.clientPrincipal && (
									<>
										<Route
											path="/portal/*"
											element={
												<ProtectedComponent
													authenticated
													redirectPath="/access-denied/"
													roles={["valid-contact"]}
													requireAllRoles>
													<PortalRoutes />
												</ProtectedComponent>
											}></Route>
										<Route path="/access-denied/*" element={<AccessDenied />}></Route>
									</>
								)}
							</>
						)}
					</Routes>
				</BrowserRouter>
			</FluentProvider>
		</SuperUserContext.Provider>
	);
}

export default App;
